import { httpClient } from '@/core/services/http'
import { memroyTokenService } from '@/core/services/tokens/client'
import { createAddTripUseCase } from '../use-cases/add-trip.usecase'
import { createAskForPaymentUseCase } from '../use-cases/ask-for-payment.usecase'
import { createAskForRefundUseCase } from '../use-cases/ask-for-refund.usecase'
import createCheckPromoCodeUseCase from '../use-cases/chech-promo-code.usecase'
import { createConfirmPaymentUseCase } from '../use-cases/confirm-payment.usecase'
import { createGetTripInfoUseCase } from '../use-cases/get-trip-info.usecase'
import { createRefundUseCase } from '../use-cases/refund.usecase'
import { createUpdateTripUseCase } from '../use-cases/update-trip.usecase'

export const getTripInfo = createGetTripInfoUseCase({
  httpClient,
  tokenService: memroyTokenService,
})

export const addTrip = createAddTripUseCase({
  httpClient,
  tokenService: memroyTokenService,
})

export const updateTrip = createUpdateTripUseCase({
  httpClient,
  tokenService: memroyTokenService,
})

export const askForPayment = createAskForPaymentUseCase({
  httpClient,
  tokenService: memroyTokenService,
})

export const confirmPayment = createConfirmPaymentUseCase({
  httpClient,
  tokenService: memroyTokenService,
})
export const askForRefund = createAskForRefundUseCase({
  httpClient,
  tokenService: memroyTokenService,
})
export const refund = createRefundUseCase({
  httpClient,
  tokenService: memroyTokenService,
})
export const checkPromoCode = createCheckPromoCodeUseCase({
  httpClient,
  tokenService: memroyTokenService,
})
